module.exports = __webpack_public_path__ + "static/media/twitter-gradient.3aec5a45.svg";